import { takeLatest, put } from 'redux-saga/effects';

import {
    CANCEL_ANIMAL_PELAGEM_CADASTRO_RAPIDO,
    CANCEL_ANIMAL_PELAGEM_CADASTRO_RAPIDO_SUCCESS
} from '../actionTypes';

function* sagaCancelAnimalPelagemCadastroRapido() {
  yield put({ type: CANCEL_ANIMAL_PELAGEM_CADASTRO_RAPIDO_SUCCESS})
}

export default function* watchCancelAnimalPelagemCadastroRapido() {
  yield takeLatest(CANCEL_ANIMAL_PELAGEM_CADASTRO_RAPIDO, sagaCancelAnimalPelagemCadastroRapido)
}